import React from 'react'
import type { PresentationBlockProps } from '../../'
import compareBlockProps from '../../util/compareBlockProps'

function SpacerBlock(props: PresentationBlockProps) {
  const { WrapperComponent } = props

  return (
    <WrapperComponent {...props}>
      <div></div>
    </WrapperComponent>
  )
}

export default React.memo(SpacerBlock, (prevProps, nextProps) => {
  return compareBlockProps(prevProps, nextProps)
})
